var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF7A7A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9072 5.54941C18.9074 5.54095 18.9074 5.53281 18.9072 5.52436C18.9066 5.50377 18.9046 5.48348 18.9014 5.4632C18.9003 5.4569 18.9 5.45075 18.8986 5.44445C18.8934 5.41909 18.886 5.3942 18.8765 5.37007C18.8737 5.363 18.8702 5.3564 18.8671 5.34948C18.859 5.33119 18.8498 5.31352 18.8392 5.29631C18.8348 5.28924 18.8305 5.28217 18.8258 5.2751C18.8101 5.25251 18.7932 5.23085 18.7734 5.21102C18.7534 5.19104 18.7314 5.17399 18.7087 5.15816C18.7022 5.1537 18.6956 5.14955 18.6889 5.14556C18.6707 5.13434 18.6521 5.12466 18.6329 5.11621C18.6269 5.11359 18.6212 5.11052 18.6151 5.10806C18.5904 5.09838 18.5648 5.0907 18.5387 5.08547C18.534 5.08455 18.529 5.08424 18.5243 5.08332C18.5025 5.07963 18.4805 5.07748 18.4584 5.07702C18.451 5.07687 18.4438 5.07687 18.4365 5.07702C18.4149 5.07748 18.3932 5.07963 18.3715 5.08332C18.3661 5.08424 18.3609 5.08455 18.3555 5.08563C18.3319 5.09039 18.3085 5.09684 18.2855 5.10545L5.37596 9.94965C5.20323 10.0145 5.08583 10.176 5.07737 10.3604C5.06908 10.5447 5.17142 10.7163 5.33754 10.7965L10.6323 13.3518L13.1874 18.6466C13.2647 18.8065 13.4265 18.9073 13.6028 18.9073C13.6099 18.9073 13.6168 18.9072 13.6238 18.9069C13.8081 18.8984 13.9698 18.781 14.0346 18.6083L18.879 5.69893C18.8876 5.67603 18.8939 5.65283 18.8986 5.62932C18.8999 5.62302 18.9003 5.61687 18.9012 5.61057C18.9046 5.59028 18.9066 5.56985 18.9072 5.54941ZM16.6155 6.71685L10.8834 12.449L6.70875 10.4345L16.6155 6.71685ZM13.5498 17.2755L11.5353 13.101L17.2675 7.36873L13.5498 17.2755Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/sendButton.cca3e9ca72869998856ed62b95dfefba.svg";
export { ForwardRef as ReactComponent };